/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Boolean field representation.
 */
export interface ClaimsSchemaFieldBooleanValue {
    /** Determine whether the field values should be an array. */
    isArray?: boolean;
    /** The IRI of the JSON-LD context that will be used to generate the vocabulary. */
    jsonLdIri?: string;
    /** The JSON-LD type of the field. */
    jsonLdType?: string;
    /** Field name. */
    name: string;
    notEmpty?: boolean;
    /** The human-readable name of the field can be used to display the field in the UI. */
    title?: string;
}
